module.exports = __webpack_public_path__ + "static/rare-e55208a889cc61b363f0366af5f7dc3f.png";